/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_5_AInputs */

const en_cp_faq_5_a = /** @type {(inputs: Cp_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data is used only to run the program, stored on servers in Indonesia, and deleted on request. Student work stays with the students/campus under campus rules.`)
};

const id_cp_faq_5_a = /** @type {(inputs: Cp_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data dipakai hanya untuk operasional program, disimpan di server Indonesia, dan dihapus atas permintaan. Karya mahasiswa tetap milik mahasiswa/kampus sesuai aturan kampus.`)
};

/**
* | output |
* | --- |
* | "Data is used only to run the program, stored on servers in Indonesia, and deleted on request. Student work stays with the students/campus under campus rules." |
*
* @param {Cp_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_5_a = /** @type {((inputs?: Cp_Faq_5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_5_a(inputs)
	return en_cp_faq_5_a(inputs)
});